/**
 * Basic plan list price and first-month intro price. The paywall (PaywallPage)
 * builds its Basic plan from these, and the logged-out home feed quotes them,
 * so the landing copy always matches what checkout charges.
 */
export const BASIC_PLAN_PRICE = 34.99;
export const BASIC_PLAN_INTRO_PRICE = 17.5;
/** Plus and Pro list and first-month prices (the paywall's plan cards and the landing's pricing section). */
export const PLUS_PLAN_PRICE = 59.99;
export const PLUS_PLAN_INTRO_PRICE = 30;
export const PRO_PLAN_PRICE = 99;
export const PRO_PLAN_INTRO_PRICE = 49.5;

/**
 * Plan cards for the landing's pricing section (and llms.txt); prices come from the same
 * constants the paywall charges.
 */
export const PRICING_PLANS = [
  { id: "basic", name: "Basic", price: BASIC_PLAN_PRICE, intro: BASIC_PLAN_INTRO_PRICE, highlight: false, features: ["1 home store at Walmart and HD", "4 extra nearby stores at each", "5 price alerts"] },
  { id: "plus", name: "Plus", price: PLUS_PLAN_PRICE, intro: PLUS_PLAN_INTRO_PRICE, highlight: false, features: ["Up to 3 home stores per chain", "7 extra nearby stores at Walmart and HD", "9 chains", "7 price alerts"] },
  { id: "pro", name: "Pro", price: PRO_PLAN_PRICE, intro: PRO_PLAN_INTRO_PRICE, highlight: true, features: ["Up to 5 home stores per chain", "15 extra nearby at Walmart, 10 at HD", "Hawk Finds", "10 price alerts"] },
];

/** Two-decimal price without rounding up (17.495 → "17.49"), as the paywall shows it. */
export const formatPlanPrice = (price: number) => (Math.floor(price * 100) / 100).toFixed(2);

/** "$17.50" */
export const BASIC_INTRO_LABEL = `$${formatPlanPrice(BASIC_PLAN_INTRO_PRICE)}`;
/** "$34.99" */
export const BASIC_PRICE_LABEL = `$${formatPlanPrice(BASIC_PLAN_PRICE)}`;
